"use client";
import React from "react";
import { Button } from "@/components/ui/button";
import Link from "next/link";

// Error - Last resort fallback when cache completely fails
export default function Error({ error, reset }) {
  // Log the error for debugging but try to auto-recover
  console.error('🚨 Critical error reached error boundary:', error);

  // Auto-retry after 3 seconds
  React.useEffect(() => {
    const timer = setTimeout(() => {
      console.log('🔄 Auto-retrying after critical error...');
      reset();
    }, 3000);
    return () => clearTimeout(timer);
  }, [reset]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[70dvh] py-16 mx-auto space-y-6 px-6 text-center bg-brand-wool">
      <div className="flex flex-col items-center max-w-lg gap-4">
        <p className="level-2 font-heading text-brand-espresso">
          We&apos;ll be back soon
        </p>
        <p className="font-body text-brand-espresso/80">
          Something went wrong loading this page. Please try again in a moment.
        </p>
        <Button type="button" onClick={() => reset()} className="mt-2">
          Try again
        </Button>
        <Link href="/" className="text-sm underline text-brand-espresso/60">
          Return home
        </Link>
      </div>
    </div>
  );
}
